import apiHandler from "../core/apiHandler";

/**
 * 🖨️ QZ Tray Payload API
 *
 * API para generar payloads listos para impresión (QZ Tray).
 *
 * ✅ Endpoints:
 * - GET /api/printing/qztray/payload?type=SALE&id=152
 */
const qzTrayPayloadApi = apiHandler("printing/qztray");

export default qzTrayPayloadApi;
